import http from "./http-common";

class IPDOrderService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
  }
  getIPDOrderDetails(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/PatientIpdOrderHdr/list/filter?${queryString}`);
  }

  saveIPDOrder(payload) {
    return http.post(`/PatientIpdOrderHdr/`, payload);
  }

  DeletePatientOrder(payload) {
    const queryString = this.queryString(payload);
    return http.delete(`/PatientIpdOrderHdr/delete?${queryString}`);
  }

}

export default new IPDOrderService();
